/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faEdit,
  faEye,
  faToggleOn,
  faToggleOff,
  faFilePdf,
  faTimes
} from "@fortawesome/free-solid-svg-icons";
import Modal from "../components/Modal";
import CampaignForm from "./CampaignForm";
import AzureOpenAIModal from "./AzureOpenAIModal";
import AdbotDashboardForm from "../features/AdbotDashboardForm";
import {
  selectCampaigns,
  updateCampaignStatus,
  fetchCampaigns,
  deleteCampaign,
  removeCampaign,
  updateCampaignDetails,
  addDashboardToCampaignSuccess,
  updateAzureOpenAIConfig,
} from "./campaignSlice";



const CampaignPreviewModal = ({ campaignUrl, onClose }) => {
  const [selectedView, setSelectedView] = useState("full"); // Default view is full window
  
  const handleViewChange = (view) => {
    setSelectedView(view);
  };

  return (
<Modal onClose={onClose} width={selectedView === "full" ? 1080 : 350} height={selectedView === "full" ? 768 : 250}>
<div className="campaign-container">
  <div className="left-panel">
    <div className="view-options">
      <button className={`view-option ${selectedView === "full" ? "active" : ""}`} onClick={() => handleViewChange("full")}>
        Full Window
      </button>
      <button className={`view-option ${selectedView === "mobile" ? "active" : ""}`} onClick={() => handleViewChange("mobile")}>
        Mobile View
      </button>
      <button className={`view-option ${selectedView === "300x250" ? "active" : ""}`} onClick={() => handleViewChange("300x250")}>
        300x250
      </button>
    </div>
  </div>
  <div className="right-panel">
    <div className="campaign-preview-container">
      <button className="close-button" onClick={onClose}>
        <FontAwesomeIcon icon={faTimes} />
      </button>
      <iframe
        src={campaignUrl}
        width={selectedView === "full" ? "1080px" : selectedView === "mobile" ? "375px" : "300px"}
        height={selectedView === "full" ? "768px" : selectedView === "mobile" ? "667px" : "250px"}
        frameBorder="0"
        title="Campaign Preview"
      />
    </div>
  </div>
</div>
</Modal>

  );
};

function CampaignTable() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchCampaigns());
  }, [dispatch]);

  const campaigns = useSelector(selectCampaigns).map((campaign) => ({
    ...campaign,
    status: campaign.status || "red",
  }));

  const [openModal, setOpenModal] = useState(false);
  const [selectedCampaignId, setSelectedCampaignId] = useState(null);
  const [openDashboardModal, setOpenDashboardModal] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [campaignToDelete, setCampaignToDelete] = useState(null);
  const [showCampaignPreviewModal, setShowCampaignPreviewModal] = useState(false);
  const [campaignPreviewUrl, setCampaignPreviewUrl] = useState("");
  const [showPublishConfirmation, setShowPublishConfirmation] = useState(false);
  const [campaignToPublish, setCampaignToPublish] = useState(null);
  const [showDeletePublishedWarning, setShowDeletePublishedWarning] = useState(false);
  const [showAzureOpenAIModal, setShowAzureOpenAIModal] = useState(false);
  const [selectedAzureCampaignId, setSelectedAzureCampaignId] = useState(null);

  
  //--------pagination---------
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10); 
  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
 
  const offset = currentPage * itemsPerPage;
  const currentCampaigns = campaigns.slice(offset, offset + itemsPerPage);

  //-------till here-------


  //----------drop down menu----------

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0); 
  };

  //-------till here-------

  const handleOpenAzureOpenAIModal = (campaignId) => {
    setSelectedAzureCampaignId(campaignId);
    setShowAzureOpenAIModal(true);
  };

  const handleCloseAzureOpenAIModal = () => {
    setShowAzureOpenAIModal(false);
    setSelectedAzureCampaignId(null);
  };
  
  const handleRemoveCampaign = async (campaignId) => {
    try {
      await dispatch(deleteCampaign(campaignId));
      dispatch(removeCampaign(campaignId));
      setShowDeleteConfirmation(false); // Close the confirmation modal after deleting the campaign
    } catch (error) {
      console.error("Failed to delete campaign:", error.message);
    }
  };

  const handleDeleteConfirmation = (campaignId) => {
    const campaignToDelete = campaigns.find((campaign) => campaign.id === campaignId);
    if (campaignToDelete.status === "published") {
      setShowDeletePublishedWarning(true);
    } else {
      setCampaignToDelete(campaignId);
      setShowDeleteConfirmation(true);
    }
  };

  const handleCloseDeletePublishedWarning = () => {
    setShowDeletePublishedWarning(false);
  };

  const fetchCampaignStatus = async (campaignId, campaignName, newStatus) => {
    try {
      const response = await fetch(`https://adbot.nw18.com/api/updateCampaign/${campaignId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name: campaignName, status: newStatus }),
      });

      if (!response.ok) {
        throw new Error('Failed to update campaign status');
      }

      dispatch(updateCampaignStatus({ campaignId, campaignName, newStatus }));
    } catch (error) {
      console.error('Failed to update campaign status:', error.message);
    }
  };

  const handleStatusChange = (campaignId) => {
    const campaign = campaigns.find((campaign) => campaign.id === campaignId);
    const newStatus = campaign.status === "draft" ? "published" : "draft";
    setCampaignToPublish(campaignId);
    setShowPublishConfirmation(true);
  };

  const onHandleClick = (campaignId) => {
    setSelectedCampaignId(campaignId);
    setOpenDashboardModal(true);
  };

  const onHandleClose = () => {
    setOpenModal(false);
    setOpenDashboardModal(false);
    setShowDeleteConfirmation(false);
    setShowPublishConfirmation(false);
    setShowDeletePublishedWarning(false);
  };

  const openEditForm = (campaignId) => {
    setSelectedCampaignId(campaignId);
    setOpenModal(true);
  };

  const handleUpdateCampaign = (updatedCampaign) => {
    dispatch(updateCampaignDetails(updatedCampaign));
    setOpenModal(false);
  };

  const handleAddDashboardSuccess = (payload) => {
    dispatch(addDashboardToCampaignSuccess(payload));
  };

  const handleOpenCampaignPreviewModal = (campaignUrl) => {
    setCampaignPreviewUrl(campaignUrl);
    setShowCampaignPreviewModal(true);
  };

  const handleCloseCampaignPreviewModal = () => {
    setShowCampaignPreviewModal(false);
    setCampaignPreviewUrl("");
  };

  const handlePublishConfirmationResponse = async (confirmation) => {
    if (confirmation) {
      const campaign = campaigns.find((campaign) => campaign.id === campaignToPublish);
      const newStatus = campaign.status === "draft" ? "published" : "draft";
      await fetchCampaignStatus(campaignToPublish, campaign.name, newStatus);
    }
    setShowPublishConfirmation(false);
  };

  const handleSaveAzureConfig = async (azureOpenAI, systemMessage) => {
    try {
      const campaign = campaigns.find((c) => c.id === selectedAzureCampaignId);
 
      if (!campaign) {
        throw new Error("Campaign not found");
      }
      
      if(typeof(systemMessage)==="object"){
        systemMessage=systemMessage.systemMessage
      }
      const updatedCampaign = {
        azureOpenAI: azureOpenAI,
        systemMessage: systemMessage
      };
      const response = await fetch(`https://adbot.nw18.com/api/updateCampaign/${selectedAzureCampaignId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedCampaign),
      });
 
      if (!response.ok) {
        throw new Error('Failed to update campaign');
      } 
      dispatch(updateAzureOpenAIConfig({ campaignId: selectedAzureCampaignId, azureOpenAI, systemMessage }));

      handleCloseAzureOpenAIModal();

      const s=await response.json();
      return s;

    } catch (error) {
      console.error('Failed to save Azure OpenAI config:', error.message);
    }
  };

  return (
    <>
      <section className="campaigns">
        {campaigns.length > 0 ? (
          <>
           <div className="items-per-page">
            <label htmlFor="items-per-page" className="label">Show result</label>
            <div className="dropdown">
              <select
                id="items-per-page"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                className="dropdown-select"
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>Serial No.</th>
                <th>Name</th>
                <th>Domain</th>
                <th>Created at</th>
                <th>Design Adbot</th>
                <th>Azure Keys</th>
                <th>Status</th>
                <th className="action-row">Actions</th>               
              </tr>
            </thead>
            <tbody>
              {currentCampaigns.map((campaign, index) => (
                <tr key={campaign.id}>
                  <td>{offset + index + 1}</td>
                  <td>{campaign.name}</td>
                  <td>
                    <a href={`https://${campaign.subDomain}.adbot.nw18.com`} target="_blank" rel="noopener noreferrer">{campaign.subDomain}</a>
                  </td>
                  <td>
                    {new Date(campaign.createdAt).toLocaleString("en-IN", {
                      timeZone: "Asia/Kolkata",
                    })}
                  </td>
                  <td>
                    <button
                      onClick={() => onHandleClick(campaign.id)}
                      className="button bg-[#c95128] text-white px-6 py-3"
                    >
                      + Attributes
                    </button>
                  </td>
                  <td>
                    <button 
                      onClick={() => handleOpenAzureOpenAIModal(campaign.id)}
                      className="button bg-[#28a745] text-white px-6 py-3"
                    >+ Add</button>
                  </td>
                  <td>
                    <FontAwesomeIcon
                      icon={campaign.status === "draft" ? faToggleOff : faToggleOn}
                      className={`status-icon ${
                        campaign.status === "draft" ? "status-red" : "status-green"
                      }`}
                      onClick={() => handleStatusChange(campaign.id)}
                    />
                  </td>
                  <td>
                    <a href={campaign.pdfFile} target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={faFilePdf} className="pdf-icon" />
                    </a>
                    <FontAwesomeIcon icon={faEdit} onClick={() => openEditForm(campaign.id)} className="edit" />
                    <FontAwesomeIcon icon={faEye} className="eye" 
                      onClick={() => handleOpenCampaignPreviewModal(`https://${campaign.subDomain}.adbot.nw18.com/?appId=22121998`)} />
                    <FontAwesomeIcon icon={faTrash} onClick={() => handleDeleteConfirmation(campaign.id)} className="delete" />
                  </td>    
                </tr>
              ))}
            </tbody>
          </table>
          <div className="pagination" >
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={Math.ceil(campaigns.length / itemsPerPage)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          </div>
 </>
        ) : (
          <p>No campaigns available</p>
        )}

     
      </section>

      {showDeleteConfirmation && (
        <Modal onClose={() => setShowDeleteConfirmation(false)}>
          <div className="confirmation-modal">
            <p>Are you sure you want to delete this campaign?</p>
            <button onClick={() => handleRemoveCampaign(campaignToDelete)}>Yes</button>
            <button className="cancel-button" onClick={() => setShowDeleteConfirmation(false)}>No</button>
          </div>
        </Modal>
      )}

      {showDeletePublishedWarning && (
        <Modal onClose={handleCloseDeletePublishedWarning}>
          <div className="confirmation-modal">
            <p>You can't delete a published campaign.</p>
            <button className="cancel-button" onClick={handleCloseDeletePublishedWarning}>Close</button>
          </div>
        </Modal>
      )}

      {showPublishConfirmation && (
        <Modal onClose={() => handlePublishConfirmationResponse(false)}>
          <div className="confirmation-modal">
            <p>
              Are you sure you want to change the status of campaign{" "}
              <strong style={{ color: "red" }}>
                {campaigns.find((campaign) => campaign.id === campaignToPublish)?.name}
              </strong>{" "}
              to{" "}
              <strong style={{ color: "red" }}>
                {campaigns.find((campaign) => campaign.id === campaignToPublish)?.status ===
                "draft"
                  ? "published"
                  : "draft"}
              </strong>
              ?
            </p>
            <button onClick={() => handlePublishConfirmationResponse(true)}>Yes</button>
            <button className="cancel-button" onClick={() => handlePublishConfirmationResponse(false)}>No</button>
          </div>
        </Modal>
      )}

      {showCampaignPreviewModal && (
        <CampaignPreviewModal
          campaignUrl={campaignPreviewUrl}
          onClose={handleCloseCampaignPreviewModal}
        />
      )}

      {showAzureOpenAIModal && (
        <AzureOpenAIModal
          azureOpenAIConfig={
            campaigns.find((campaign) => campaign.id === selectedAzureCampaignId)?.azureOpenAI || {}
          }

          systemMessage={
            campaigns.find((campaign) => campaign.id === selectedAzureCampaignId)
          }
          
          onClose={handleCloseAzureOpenAIModal}
          onSave={handleSaveAzureConfig }
        />
      )}


    {openDashboardModal && (
      <Modal onClose={onHandleClose}>
        <AdbotDashboardForm
          campaignId={selectedCampaignId}
          campaignName={campaigns.find((campaign) => campaign.id === selectedCampaignId)?.name}
          campaignDomain={campaigns.find((campaign) => campaign.id === selectedCampaignId)?.subDomain}
          campaignFallBackUrl={campaigns.find((campaign) => campaign.id === selectedCampaignId)?.fallBackUrl}
          campaign={campaigns.find((campaign) => campaign.id === selectedCampaignId)}
          campaignStatus={campaigns.find((campaign) => campaign.id === selectedCampaignId)?.status}
          campaignLeadQuestionNumber={campaigns.find((campaign) => campaign.id === selectedCampaignId)?.body.leadQuestionNumber}
          campaignLeadFields={campaigns.find((campaign) => campaign.id === selectedCampaignId)?.body.leadFields}
          onHandleClose={onHandleClose}
          onAddDashboardSuccess={handleAddDashboardSuccess}
        />
      </Modal>
    )}

      {openModal && (
        <Modal onClose={onHandleClose}>
          <CampaignForm
            campaign={campaigns.find((campaign) => campaign.id === selectedCampaignId)}
            onHandleClose={onHandleClose}
            onUpdate={handleUpdateCampaign}
          />
        </Modal>
      )} 
    </>
  );
  
}

export default CampaignTable;
